<ion-tabs>
  <ion-tab-bar color="primary">
    <ion-tab-button tab="start">
      <ion-icon name="home" />
      <ion-label>{{ 'tab.start' | translate }}</ion-label>
      @if (unreadNotifications() > 0) {
        <ion-badge color="tertiary">{{ unreadNotifications() }}</ion-badge>
      }
    </ion-tab-button>

    @if (showContent()) {
      <ion-tab-button tab="content">
        <ion-icon name="newspaper" />
        <ion-label>{{ 'tab.news' | translate }}</ion-label>
      </ion-tab-button>
    }

    @if (liveTab(); as liveTab) {
      <ion-tab-button tab="live">
        <ion-icon [name]="liveTabIcon()" />
        <ion-label>{{ `tab.${liveTab}` | translate }}</ion-label>
        @if (unreadFollowees() > 0) {
          <ion-badge color="tertiary">{{ unreadFollowees() }}</ion-badge>
        }
      </ion-tab-button>
    }

    <ion-tab-button tab="photos">
      <ion-icon name="albums" />
      <ion-label>{{ 'tab.photos' | translate }}</ion-label>
    </ion-tab-button>

    @if (showInformation()) {
      <ion-tab-button tab="information">
        <ion-icon name="information-circle" />
        <ion-label>{{ 'tab.information' | translate }}</ion-label>
      </ion-tab-button>
    }
  </ion-tab-bar>
</ion-tabs>
